module.exports = __webpack_public_path__ + "static/media/thumbnail-lg-klima-projekmenedzsment.e346de5f.jpg";